import React from 'react';
import './App.css';
import ApiProvider from './contexts/ApiContext';
import AuthProvider from './contexts/AuthContext';
import { ThemeTypeProvider } from './contexts/ThemeTypeContext';
import RouteWrapper from './RouteWrapper';

function App() {
  return (
    <div className="App">
      <AuthProvider>
        <ApiProvider>
          <ThemeTypeProvider>
            <RouteWrapper />
          </ThemeTypeProvider>
        </ApiProvider>
      </AuthProvider>
    </div>
  );
}

export default App;
